import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgaben-benutzer-berechtigungen-entfernen';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenAufgabenBenutzerBerechtigungenEntfernenEffects {

    AufgabenBenutzerBerechtigungenEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ENTFERNEN),
        mergeMap((x: ac.PostAufgabenBenutzerBerechtigungenEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabenBenutzerBerechtigungenEntfernen(x.aufgabenBenutzerIdsRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabenBenutzerBerechtigungenEntfernenErfolgreichAction(x.aufgabenBenutzerIdsRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabenBenutzerBerechtigungenEntfernenFehlerAction(error, x.aufgabenBenutzerIdsRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AufgabenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AufgabenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AufgabenCommandService);
        }
        return this.service;
    }
}
